const BlankLayout = ({ children }) => {
  return <>{children}</>;
};

export default BlankLayout;
